module.exports = __webpack_public_path__ + "media/images/features/draft/bnr-posting-7dadd789a79def2c20c082afad8a7f99.svg";